import { c as _c } from "react-compiler-runtime";
import * as React from "react";
import { cn } from "@/core/utils";
const Input = React.forwardRef<HTMLInputElement, React.ComponentProps<"input">>((t0, ref) => {
  const $ = _c(11);
  let className;
  let props;
  let type;
  if ($[0] !== t0) {
    ({
      className,
      type,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = props;
    $[3] = type;
  } else {
    className = $[1];
    props = $[2];
    type = $[3];
  }
  let t1;
  if ($[4] !== className) {
    t1 = cn("border-input type-body-md file:text-foreground placeholder:text-muted-foreground/60 focus-visible:border-primary file:type-body-sm flex h-12 w-full rounded-md border bg-white px-4 py-3 transition-all duration-300 file:border-0 file:bg-transparent file:font-medium focus-visible:ring-0 focus-visible:outline-none disabled:cursor-not-allowed disabled:opacity-50", className);
    $[4] = className;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  let t2;
  if ($[6] !== props || $[7] !== ref || $[8] !== t1 || $[9] !== type) {
    t2 = <input className={t1} ref={ref} type={type} {...props} />;
    $[6] = props;
    $[7] = ref;
    $[8] = t1;
    $[9] = type;
    $[10] = t2;
  } else {
    t2 = $[10];
  }
  return t2;
});
Input.displayName = "Input";
export { Input };